const LOCATION_SIGNAL_DATAPOINT = {
  id: 'fix_quality',
  description: 'Location Signal Quality',
  checkedDatapoint: false
};

const FIRMWARE_VERSION_DATAPOINT = {
  id: 'firmware_ver',
  description: 'Device Firmware Version',
  checkedDatapoint: false
};

const CONFIGURATION_VERSION_DATAPOINT = {
  id: 'config_ver',
  description: 'Device Configuration Version',
  checkedDatapoint: false
};

export default function DatapointMultiPickerController(
  $rootScope,
  $scope,
  $filter,
  usersService,
  EquipmentService,
  $uibModalInstance,
  selectedDatapoints,
  assetsSelected,
  singleSelect,
  maxSelection,
  includeDiagnosticDatapoints,
  gettextCatalog,
) {
  'ngInject';

  var tag = 'DatapointMultiPickerController';

  //INIT LOCAL VARIABLES
  $scope.loading = true;
  $scope.success = false;
  $scope._selectedDatapoints = selectedDatapoints ? selectedDatapoints : {};
  $scope.unavailableDatapoints = {};
  if (singleSelect) {
    $scope.unavailableDatapoints = angular.copy($scope._selectedDatapoints);
    $scope._selectedDatapoints = {};
  }

  $scope.isDirty = false;

  $scope.filters = {};
  $scope.currentPage = 1;
  $scope.pages = [];
  $scope.limit = 15;
  $scope.maxSize = 1;
  $scope.firstPage = 'First';
  $scope.lastPage = 'Last';
  $scope.select = {};
  $scope.select.all = false;
  $scope.infoMessage = '';
  $scope.selectLimit = parseInt(maxSelection);
  $scope.filterCount = 0;
  $scope.singleMode = singleSelect;
  //Pagination
  $scope.currentPageSelectedDatapoints = [];
  $scope.bigCurrentPage = 1;
  $scope.itemsPerPage = 300;

  $scope.facets = null;

  //Sorting
  $scope.predicate1 = 'description';
  $scope.reverse1 = true;
  var orderBy = $filter('orderBy');

  //Sort filteredDataPoints
  $scope.orderDataPoints = function(predicate1) {
    $scope.predicate1 = predicate1;
    $scope.reverse1 = $scope.predicate1 === predicate1 ? !$scope.reverse1 : false;

    angular.forEach($scope.filteredDataPoints, function(datapoint) {
      datapoint[predicate1] = datapoint[predicate1];
    });
    $scope.filteredDataPoints = orderBy($scope.filteredDataPoints, predicate1, $scope.reverse1);
    $scope.displayDataPointsByPage();
  };

  //Pagination
  $scope.current = {
    page: 1,
    policyPage: 1
  };
  $scope.maxSize = 1;

  //displayDataPointsByPage() is used to set the legnth of paging needed for filteredUserRoles.
  $scope.displayDataPointsByPage = function() {
    $scope.totalItems = $scope.filteredDataPoints.length;
    var begin = ($scope.current.page - 1) * $scope.itemsPerPage;
    var end = begin + $scope.itemsPerPage;
    $scope.dataPointsByPage = $scope.filteredDataPoints.slice(begin, end);
    $scope.select.all = isDataPointsInthePageAllSelected($scope.dataPointsByPage);
    $scope.loading = false;
  };

  var isDataPointsInthePageAllSelected = function(allDataPointsInthePage) {
    var arr = Object.keys($scope._selectedDatapoints);
    for (var i = 0; i < allDataPointsInthePage.length; i++) {
      if (!$scope._selectedDatapoints[allDataPointsInthePage[i].id]) {
        return false;
      }
    }

    return true;
  };

  //displayDataPointsByPage() is used to set the legnth of paging needed for filteredUserRoles.
  $scope.displaySelectedDataPointsByPage = function() {
    // $scope.totalItems = $scope.numSelectedDatapoints();
    var begin = ($scope.bigCurrentPage - 1) * $scope.itemsPerPage;
    var end = begin + $scope.itemsPerPage;
    var arr = Object.keys($scope._selectedDatapoints).slice(begin, end);
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === 'undefined') {
        delete $scope._selectedDatapoints[arr[i]];
      }
    }
    return Object.keys($scope._selectedDatapoints).slice(begin, end);
  };
  //Calls displayUserRolesByPage(), everytime the the user changes the page.
  $scope.pageChanged = function() {
    $scope.select.all = false;
    $scope.displayDataPointsByPage();
  };

  //applyFilter searchs the roles[] for anything matching the search input.
  $scope.applyFilter = function() {
    if ($scope.search === undefined) {
      $scope.search = {};
      $scope.search.query = '';
    }
    $scope.filteredDataPoints = $filter('filter')($scope.datapoints, $scope.search.query);
    $scope.displayDataPointsByPage();
  };

  $scope.getSelectedDatapoints = function() {
    var datapoints = [];
    for (var key in $scope._selectedDatapoints) {
      if ($scope._selectedDatapoints.hasOwnProperty(key)) {
        datapoints.push(key);
        $scope.size++;
      }
    }
    return datapoints;
  };

  var deselectDatapoint = function(datapoint) {
    if (!datapoint) return;
    if ($scope.unavailableDatapoints[datapoint.id]) return;
    datapoint.selected = false;

    delete $scope._selectedDatapoints[datapoint.id];
    $scope.select.all = false;
  };

  $scope.selectAll = function() {
    if ($scope.select.all) {
      for (var i = 0; i < $scope.dataPointsByPage.length; i++) {
        if ($scope.selectLimit > 0 && $scope.numSelectedDatapoints() >= $scope.selectLimit) {
          $scope.infoMessage = 'Only ' + maxSelection + ' datapoint(s) can be selected at this time.';
          break;
        }
        $scope._selectedDatapoints[$scope.dataPointsByPage[i].id] = $scope.dataPointsByPage[i];
      }
    } else if (!$scope.select.all) {
      for (var i = 0; i < $scope.dataPointsByPage.length; i++) {
        deselectDatapoint($scope.dataPointsByPage[i]);
      }
    }
  };

  $scope.isAllDatapointSelected = function() {
    for (var i = 0; i < $scope.datapoints.length; i++) {
      var hasSelected = false;
      for (var key in $scope._selectedDatapoints) {
        if ($scope.datapoints[i].id == key) {
          hasSelected = true;
          break;
        }
      }
      if (!hasSelected) return false;
    }
    return true;
  };

  //WATCH FUNCTIONS
  $scope.$watch(
    'filters',
    function(newValue, oldValue) {
      $scope.currentPage = 1;
      // refresh();
    },
    true
  );

  //PUBLIC METHODS
  $scope.selectPage = function(page) {
    $scope.select.all = false;
    $scope.selectedPage = page;
    // refresh();
  };

  $scope.submitQuery = function(searchString) {
    $scope.filters.queryString = searchString;
    $scope.selectedPage = 1;
    $scope.lastSearchQuery = searchString; //store the search value entered in the textbox, so that it can be saved as part of the saved search
  };

  $rootScope.selectDatapoint = function(datapoint) {
    if (!datapoint) return;
    if ($scope.unavailableDatapoints[datapoint.id]) return;

    if (!singleSelect) {
      if (!$scope._selectedDatapoints[datapoint.id]) {
        if (parseInt(maxSelection) === 0) {
          datapoint.checkedDatapoint = true;
          $scope._selectedDatapoints[datapoint.id] = datapoint;
        } else if ($scope.numSelectedDatapoints() >= parseInt(maxSelection)) {
          $scope.infoMessage = 'Only ' + maxSelection + ' datapoint(s) can be selected at this time.';
        } else {
          $scope._selectedDatapoints[datapoint.id] = datapoint;
        }
      } else {
        deselectDatapoint(datapoint);

        if ($scope.numSelectedDatapoints() < maxSelection) {
          $scope.infoMessage = '';
        }
      }
    } else {
      if (!$scope._selectedDatapoints[datapoint.id]) {
        $scope._selectedDatapoints = {};
        $scope._selectedDatapoints[datapoint.id] = datapoint;
      } else {
        delete $scope._selectedDatapoints[datapoint.id];
      }
    }

    $scope.select.all = $scope.isAllDatapointSelected();
  };

  $scope.removeDatapoint = function(datapoint, e) {
    if (!datapoint) return;

    deselectDatapoint(datapoint);
  };

  $scope.removeAllSelectedDataPoints = function() {
    // _selectedDatapoints[datapoint]
    $scope._selectedDatapoints = {};
    $scope.select.all = false;
  };

  $scope.numSelectedDatapoints = function() {
    // return $scope.datapointsSelectedCount;
    return Object.keys($scope._selectedDatapoints).length;
  };

  //BUTTON EVENTS
  $scope.confirm = function() {
    $uibModalInstance.close($scope._selectedDatapoints);
  };

  $scope.cancel = function() {
    $uibModalInstance.dismiss('cancel');
  };

  var closeModal = function() {
    $uibModalInstance.dismiss('cancel');
  };

  $scope.$on('$locationChangeStart', function(event, next, current) {
    // Here you can take the control and call your own functions:

    $scope.cancel();
    event.preventDefault();
  });

  function preselectDatapoints(data) {
    angular.forEach($scope.displayDataPointsByPage(), function(datapoint) {
      angular.forEach($rootScope.selectedDatapoints, function(datapointId) {
        if (Datapoint.id == DatapointId) {
          $scope._selectedDatapoints[datapointId] = datapoint;
        }
      });
    });
  }

  function preselectEquips(alreadyPickedEquips) {
    angular.forEach(alreadyPickedEquips, function(equip) {
      // equip object
      var datapoint = {};
      if (typeof equip === 'string') {
        datapoint = {
          id: equip,
          name: equip,
          pick: 'picked'
        };
      } else {
        datapoint = {
          id: equip.id,
          name: equip.name,
          pick: 'picked'
        };
      }
      $scope._selectedDatapoints[datapoint.id] = datapoint;
    });
  }

  const getRoleDatapoints = function() {
    usersService.getDatapoints().then(
      function(response) {
        const dataPointObjs = {};

        $scope.datapoints = response.data;

        angular.forEach($scope.datapoints, function(obj) {
          obj['checkedDatapoint'] = false;
          dataPointObjs[obj.id] = obj;
        });

        $scope.datapointsSelectedCount = $scope.datapoints.length;

        $scope.originalDatapoints = angular.copy($scope.datapoints);
        $scope.filteredDataPoints = $scope.datapoints;
        $scope.orderDataPoints('description', false);
        $scope.loading = false;
        $scope.displayDataPointsByPage();
        if ($scope.existingNames && $scope.rolePolicies) {
          $scope.loading = false;
        }
        getDatapointsByAssetIds(assetsSelected, dataPointObjs);
      },
      function(error) {
        var errorMsg = 'An error occurred';
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        if ($scope.loading) {
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
          $scope.loading = false;
        }
      },
    );
  };

  const getDatapointsByAssetIds = function (assetIds, dataPointObjs) {
    $scope.loading = true;

    EquipmentService.getSeriesByMultipleEquipment(Object.keys(assetIds)).then(
      (response) => {
        const dataPointIdSet = new Set();
        const noDuplicateDataPoints = [];
        const seriesData = response.data;
        let hasGPS = false;

        seriesData.forEach((item) => {
          const dataId = item.tags[0];

          if (dataPointIdSet.has(dataId) === false) {
            dataPointIdSet.add(dataId);

            const dataPoint = { ...dataPointObjs[dataId] };

            // Override series title with descriptor one, make sure data point name is consistent
            // between data point picker and asset detail page
            if (item.descriptor && item.descriptor.title) {
              dataPoint.en_description = item.descriptor.title;
            } else {
              dataPoint.en_description = item.title;
            }

            dataPoint.description = gettextCatalog.getString(dataPoint.en_description);

            noDuplicateDataPoints.push(dataPoint);
            if (dataId === 'gps') hasGPS = true;
          }
        });

        if (
          includeDiagnosticDatapoints &&
          usersService.hasRequiredFeatures(['assets.diagnostics'])
        ) {
          const cellSignal = dataPointObjs['ms_cell_signal'];
          if (cellSignal) {
            noDuplicateDataPoints.push(cellSignal);
          }

          if (hasGPS) {
            noDuplicateDataPoints.push(LOCATION_SIGNAL_DATAPOINT);
          }

          noDuplicateDataPoints.push(FIRMWARE_VERSION_DATAPOINT);
          noDuplicateDataPoints.push(CONFIGURATION_VERSION_DATAPOINT);
        }

        $scope.datapoints = noDuplicateDataPoints;
        $scope.applyFilter();
        $scope.loading = false;
        $scope.success = true;
      },
      (error) => {
        let errorMsg = 'An error occurred';
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        if ($scope.loading) {
          $scope.onLoadErrorText = errorMsg;
          $scope.onLoadErrorFlag = true;
          $scope.loading = false;
        }
      },
    );
  };

  $scope.nameExists = function() {
    if (!$scope.roleName) {
      return false;
    }
    for (var i = 0; i < $scope.existingNames.length; i++) {
      if ($scope.roleName.toLowerCase() === $scope.existingNames[i].toLowerCase()) {
        return true;
      }
    }
    return false;
  };

  //  getExistingNames();
  getRoleDatapoints();

  $scope.datapointSelected = function(id) {
    for (var i = 0; i < $scope.datapointsDenied.length; i++) {
      if ($scope.datapointsDenied[i] === id) {
        $scope.datapointsDenied.splice(i, 1);
        // _selectedDatapoints[id] = $scope.datapointsDenied[i];
        $scope.datapointsSelectedCount++;
        return;
      }
    }
    $scope.datapointsDenied.push(id);
    //  delete $scope._selectedDatapoints[id];
    $scope.datapointsSelectedCount--;
  };

  $scope.datapointsDenied = [];
  $scope.checkAllDatapoints = function() {
    $scope.datapointsDenied = [];

    for (var i = 0; i < $scope.filteredDataPoints.length; i++) {
      $scope.filteredDataPoints[i].checkedDatapoint = $scope.setAll.datapoints;

      if (!$scope.filteredDataPoints[i].checkedDatapoint) {
        $scope.datapointsDenied.push($scope.filteredDataPoints[i].id);
      }
    }

    if ($scope.setAll.datapoints) {
      $scope.datapointsSelectedCount = $scope.filteredDataPoints.length;
    } else $scope.datapointsSelectedCount = 0;
  };
}
